import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { CourseDeliveryCountsResponse } from 'src/entities/Report.entity';

const requestPath = '/api/v5/reports/course_delivery_counts';
const queryPrefix = 'useCourseDeliveryCountsQuery';

type Params = {
  startOn: string;
  endOn: string;
};

const fetchCourseDeliveryCounts = ({ startOn, endOn }: Params) => async () => {
  const response = await axios.get<CourseDeliveryCountsResponse>(requestPath, {
    params: { start_on: startOn, end_on: endOn },
  });
  return response.data;
};

export const useCourseDeliveryCountsQuery = ({ startOn, endOn }: Params) => useQuery(
  [queryPrefix, { startOn, endOn }],
  fetchCourseDeliveryCounts({ startOn, endOn }),
  {
    staleTime: Infinity,
    enabled: Boolean(startOn) && Boolean(endOn),
  },
);
